module.exports = __webpack_public_path__ + "img/3.52c75d68.png";